import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4d156662"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "RenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "在本题中，你将会看到一个神经网络对图像进行加工。神经网络用一个大圆圈表示，如在例题中的大圆圈。", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "它内部包含多个小圆圈，每个小圆圈代表一个神经元。档神经元为黄色时，代表这个神经元被激活，对输入神经网络的图形进行处理。", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode("神经元"), /*#__PURE__*/_createElementVNode("b", null, "按规则"), /*#__PURE__*/_createTextVNode("对输入图形进行颜色、大小、位置、方向、线条、朝向等变化的加工，得到输出图形。")], -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("b", null, "每个神经元只运行一个规则"), /*#__PURE__*/_createTextVNode("。当一个输入图形依次经过多个被激活的神经元时，它会"), /*#__PURE__*/_createElementVNode("b", null, "按照连续的顺序"), /*#__PURE__*/_createTextVNode("被这些神经元加工。")], -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "你需要根据实例推测神经元的加工规则，并运用推测出的规则来得到问题中的输出图形。", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode("同一题中相同位置的神经元对应的规则不变，但是不同题中相同位置的神经元对应的规则可能是"), /*#__PURE__*/_createElementVNode("b", null, "不同"), /*#__PURE__*/_createTextVNode("的。")], -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "red"
  }
}, "出题模式：", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "red"
  }
}, "第一步：选择三个初始图形", -1));
const _hoisted_12 = {
  style: {
    "border": "solid"
  }
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "red"
  }
}, "第二步：对三个图形选择N个处理方式", -1));
const _hoisted_14 = {
  style: {
    "color": "red"
  }
};
const _hoisted_15 = ["src"];
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "red",
    "display": "block"
  }
}, "第三步：将方案放到题面中", -1));
const _hoisted_17 = {
  class: "questions"
};
const _hoisted_18 = {
  class: "options"
};
const _hoisted_19 = {
  class: "box"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = ["src"];
import { onMounted, ref, watch } from 'vue';
import api from "@/api";
import GraphicalReasoningItem from './GraphicalReasoningItem.vue';
import { ElLoading, ElMessage } from "element-plus";
import IconSelector from './IconSelector.vue';
export default {
  __name: 'GraphicalReasoningRender',
  props: /*#__PURE__*/_mergeModels({
    data: {
      type: Object,
      default: () => {}
    },
    editMode: {
      type: Boolean,
      default: false
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    runtimeParams: {
      type: Object,
      default: () => {
        return {};
      }
    },
    initRuntimeParams: {
      type: Array
    },
    review: {
      type: Object,
      default: () => {
        return null;
      }
    }
  }, {
    "options": {
      type: Object
    },
    "optionsModifiers": {},
    "questions": {
      type: Array
    },
    "questionsModifiers": {}
  }),
  emits: /*#__PURE__*/_mergeModels(['answer'], ["update:options", "update:questions"]),
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const previewData = ref([]);
    const selectedAnswer = ref(null);
    const initData = () => {
      selectedAnswer.value = null;
      options.value = (props.initRuntimeParams ?? props.runtimeParams)[props.data.questionIndex]?.options || {
        A: [null, null, null],
        B: [null, null, null],
        C: [null, null, null],
        D: [null, null, null]
      };
      questions.value = (props.initRuntimeParams ?? props.runtimeParams)[props.data.questionIndex]?.questions || [{
        "transforms": [],
        "input": [null, null, null],
        "output": [null, null, null]
      }, {
        "transforms": [],
        "input": [null, null, null],
        "output": [null, null, null]
      }, {
        "transforms": [],
        "input": [null, null, null]
      }];
      previewData.value = props.initRuntimeParams || [];
    };
    watch(props, newVal => {
      initData();
    });
    onMounted(() => {
      console.log(props.review);
      initData();
    });
    const options = _useModel(__props, 'options');
    const questions = _useModel(__props, 'questions');
    const handleSelect = (key, index, icon) => {
      console.log(key, index, icon, '------------');
      options.value = {
        ...options.value,
        [key]: options.value[key].map((item, i) => i === index ? icon : item)
      };
    };
    const saveAll = tplId => {
      previewData.value[props.data.questionIndex] = {
        options: options.value,
        questions: questions.value
      };
      api.updateTplRuntimeParams({
        tplId,
        runtimeParams: JSON.stringify(previewData.value, 2)
      }).then(res => {
        ElMessage({
          message: '套题已保存',
          type: 'warning'
        });
      });
    };
    const checkIsSaveAll = () => {
      return questions.value.every(item => item.transforms.length > 0 && item.input.every(i => !!i) && (item.output ? item.output.every(i => !!i) : true)) && Object.values(options.value).every(item => item.every(i => !!i));
    };
    __expose({
      saveAll,
      checkIsSaveAll
    });
    const handleUpdateNeurons = (index, neurons) => {
      questions.value = questions.value.map((item, i) => i === index ? {
        ...item,
        transforms: neurons
      } : item);
    };
    const handleUpdateInput = (index, input) => {
      questions.value = questions.value.map((item, i) => i === index ? {
        ...item,
        input
      } : item);
    };
    const handleUpdateOutput = (index, output) => {
      questions.value = questions.value.map((item, i) => i === index ? {
        ...item,
        output
      } : item);
    };
    const handleSelectAnswer = key => {
      selectedAnswer.value = key;
      emit('answer', key);
    };
    const initImgList = ref([]);
    const resultImgList = ref([]);

    // 一个神经元代表两次操作，例如：第一个小图形顺时针旋转90度，第二个小图形左右翻转。
    // 一个神经元代表三次操作，例如：第一个小图形顺时针旋转90度，第二个小图形左右翻转，第三个小图形黑白互换。
    const idMap = {
      '-2': 2,
      '-1': 3,
      '0': 0,
      '1': 1,
      '2': 2,
      '3': 3,
      '4': 0,
      '5': 1,
      '6': 2
    };
    const colorIndexMap = {
      1: 2,
      2: 1,
      3: 0,
      0: 3
    };
    // 由于历史原因，只能前端根据之前的图片命名方案推测图片变换的方案
    // 顺时针 90度 前四位数字+1， 超过3变0
    // 逆时针90度 前四位数字-1， 小于0变3
    // 镜像  上下 第一位+2  第三位-2    左右镜像2位+2 4位-2
    // 颜色变换。最后一位 2 1呼唤 30互换
    const rotateAngle = (index, direction) => {
      // 1 顺时针90 2顺时针180 -1逆时针90 -2逆时针180
      const src = resultImgList.value[index].split('/');
      const srcTail = src.pop();
      let host = src.join('/') + '/';
      const idList = srcTail.split('.');
      console.log(srcTail);
      idList.forEach((value, index) => {
        if (index === 4) {
          host += value + '.';
        } else {
          if (!Number.isNaN(Number(value))) {
            const i = idMap[`${Number(value) + direction}`];
            host += i + '.';
          } else {
            host += value;
          }
        }
      });
      console.log(host.split('/').pop());
      resultImgList.value[index] = host;
    };
    const mirror = (index, direction) => {
      // 1 左右  2 上下  3 左右+上下
      // 镜像  左右镜像2位+2 4位-2   上下 第一位+2  第三位-2    
      const src = resultImgList.value[index].split('/');
      const srcTail = src.pop();
      let host = src.join('/') + '/';
      const idList = srcTail.split('.');
      let list = [0, 0, 0, 0];
      switch (direction) {
        case 1:
          {
            list = [0, 2, 0, -2];
            break;
          }
        case 2:
          {
            list = [2, 0, -2, 0];
            break;
          }
        case 3:
          {
            list = [2, 2, -2, -2];
            break;
          }
      }
      list.forEach((value, index) => {
        idList[index] = idMap[`${Number(idList[index]) + value}`];
      });
      host += idList.join('.');
      resultImgList.value[index] = host;
      console.log(resultImgList.value);
    };
    const funcs = [{
      label: '小图形顺时针旋转90度',
      func: index => {
        rotateAngle(index, 1);
      }
    }, {
      label: '小图形顺时针旋转180度',
      func: index => {
        rotateAngle(index, 2);
      }
    }, {
      label: '小图形逆时针旋转90度',
      func: index => {
        rotateAngle(index, -1);
      }
    }, {
      label: '小图形逆时针旋转180度',
      func: index => {
        rotateAngle(index, -2);
      }
    }, {
      label: '小图形左右镜像',
      func: index => {
        mirror(index, 1);
      }
    }, {
      label: '小图形上下镜像',
      func: index => {
        mirror(index, 2);
      }
    }, {
      label: '小图形左右+上下镜像',
      func: index => {
        mirror(index, 3);
      }
    }, {
      label: '小图形12发生交换,必须选择全部',
      func: () => {
        const temp = resultImgList.value[0];
        resultImgList.value[0] = resultImgList.value[1];
        resultImgList.value[1] = temp;
      }
    }, {
      label: '小图形23发生交换,必须选择全部',
      func: () => {
        const temp = resultImgList.value[1];
        resultImgList.value[1] = resultImgList.value[2];
        resultImgList.value[2] = temp;
      }
    }, {
      label: '小图形13发生交换,必须选择全部',
      func: () => {
        const temp = resultImgList.value[0];
        resultImgList.value[0] = resultImgList.value[2];
        resultImgList.value[2] = temp;
      }
    }, {
      label: '小图形黑白互换',
      func: index => {
        // 颜色变换。最后一位 2 1互换 30互换
        const src = resultImgList.value[index].split('/');
        const srcTail = src.pop();
        let host = src.join('/') + '/';
        const idList = srcTail.split('.');
        idList[4] = colorIndexMap[Number(idList[4])];
        host += idList.join('.');
        resultImgList.value[index] = host;
        console.log(resultImgList.value);
      }
    }];
    const selectedFuncs = ref([[], [], []]);
    const funcEles = ref(0); // 0 全部
    const handleFuncs = funcItem => {
      if (funcEles.value !== 0) {
        selectedFuncs.value[funcEles.value - 1].push(funcItem);
      } else {
        selectedFuncs.value[0].push(funcItem);
        selectedFuncs.value[1].push(funcItem);
        selectedFuncs.value[2].push(funcItem);
      }
    };
    const clearSelectedFuncs = () => {
      selectedFuncs.value[0] = [];
      selectedFuncs.value[1] = [];
      selectedFuncs.value[2] = [];
      initImgList.value = [];
      resultImgList.value = [];
    };
    const handleInitSelect = (index, icon) => {
      if (initImgList.value.length === 3) {
        initImgList.value.shift();
        resultImgList.value.shift();
      }
      initImgList.value.push(icon);
      resultImgList.value.push(icon);
    };
    // const imgResult = ref(null);

    const handleResult = index => {
      resultImgList.value = [...initImgList.value];
      // imgResult.value.innerHTML="";
      Object.keys(selectedFuncs.value[0]).forEach(i => {
        // 如果有交换的情况，则只执行一次
        let breakIndex = 99;
        selectedFuncs.value.forEach((item, imgIndex) => {
          if (breakIndex === 99) {
            if (item[i].label.indexOf('交换') > -1) {
              breakIndex = i;
            }
            item[i].func(imgIndex);
          }
        });
      });
      questions.value = questions.value.map((item, i) => {
        if (i === index) return {
          ...item,
          input: [...initImgList.value],
          output: index === 2 ? null : [...resultImgList.value]
        };
        return item;
      });

      // resultImgList.value.forEach(host => {
      //   const bigImg = document.createElement("img");     //创建一个img元素  
      //   bigImg.src=host
      //   imgResult.value.appendChild(bigImg)
      // })
    };
    // 生成选项
    const handleOptions = () => {
      Object.keys(options.value).forEach(key => {
        options.value[key] = [...resultImgList.value];
        console.log(key, options.value[key]);
        if (key !== props.data.rightAnswer) {
          const i = Math.floor(Math.random() * 3);
          options.value[key][i] = null;
        }
      });
      options.value = {
        ...options.value
      };
    };
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_radio_button = _resolveComponent("el-radio-button");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_popover = _resolveComponent("el-popover");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        class: "bothCenter"
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString(__props.data.questionIndex + 1) + "题", 1)]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "flex flex-col mt16"
      }, {
        default: _withCtx(() => [_hoisted_3, _hoisted_4, _hoisted_5, _hoisted_6, _hoisted_7, _hoisted_8]),
        _: 1
      }), props.editMode ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_hoisted_9, _hoisted_10, _hoisted_11, _createElementVNode("div", _hoisted_12, [_createVNode(IconSelector, {
          onSelect: _cache[0] || (_cache[0] = $event => handleInitSelect(_ctx.index, $event)),
          editMode: props.editMode
        }, null, 8, ["editMode"])]), _hoisted_13, _createVNode(_component_el_button, {
          onClick: clearSelectedFuncs
        }, {
          default: _withCtx(() => [_createTextVNode("清空规则和图形")]),
          _: 1
        }), _createElementVNode("div", null, [_createVNode(_component_el_radio_group, {
          modelValue: funcEles.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => funcEles.value = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_button, {
            label: 0
          }, {
            default: _withCtx(() => [_createTextVNode("全部")]),
            _: 1
          }), _createVNode(_component_el_radio_button, {
            label: 1
          }, {
            default: _withCtx(() => [_createTextVNode("1")]),
            _: 1
          }), _createVNode(_component_el_radio_button, {
            label: 2
          }, {
            default: _withCtx(() => [_createTextVNode("2")]),
            _: 1
          }), _createVNode(_component_el_radio_button, {
            label: 3
          }, {
            default: _withCtx(() => [_createTextVNode("3")]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), _createElementVNode("div", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(funcs, item => {
          return _createVNode(_component_el_button, {
            key: item.label,
            onClick: $event => handleFuncs(item)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
            _: 2
          }, 1032, ["onClick"]);
        }), 64))])]), _createElementVNode("div", _hoisted_14, [_createTextVNode("已选图形： "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(initImgList.value, icon => {
          return _openBlock(), _createElementBlock("span", {
            key: icon
          }, [_createElementVNode("img", {
            style: {
              "display": "inline-block",
              "margin": "3px"
            },
            src: icon,
            alt: "icon",
            class: "w-5 h-5 object-contain"
          }, null, 8, _hoisted_15)]);
        }), 128))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFuncs.value, (itemList, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, [_createTextVNode(" 第" + _toDisplayString(index + 1) + "个图形的处理方式是： ", 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemList, (item, itemIndex) => {
            return _openBlock(), _createElementBlock("span", {
              style: {
                "color": "red"
              },
              key: itemIndex
            }, _toDisplayString(item.label) + ", ", 1);
          }), 128))]);
        }), 128))]), _hoisted_16, _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = $event => handleResult(0))
        }, {
          default: _withCtx(() => [_createTextVNode("放到第一个")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[3] || (_cache[3] = $event => handleResult(1))
        }, {
          default: _withCtx(() => [_createTextVNode("放到第二个")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = $event => handleResult(2))
        }, {
          default: _withCtx(() => [_createTextVNode("放到第三个")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleOptions
        }, {
          default: _withCtx(() => [_createTextVNode("生成选项")]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_row, {
        class: "bothCenter mt32"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (item, index) => {
            return _openBlock(), _createBlock(GraphicalReasoningItem, {
              "edit-mode": props.editMode,
              key: index,
              neurons: item.transforms,
              input: item.input,
              output: item.output,
              "onUpdate:neurons": $event => handleUpdateNeurons(index, $event),
              "onUpdate:input": $event => handleUpdateInput(index, $event),
              "onUpdate:output": $event => handleUpdateOutput(index, $event)
            }, null, 8, ["edit-mode", "neurons", "input", "output", "onUpdate:neurons", "onUpdate:input", "onUpdate:output"]);
          }), 128))])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option, key) => {
            return _openBlock(), _createElementBlock("div", {
              class: "option",
              key: key
            }, [_createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(option, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                class: "w-8 h-8 flex items-center justify-center"
              }, [props.editMode ? (_openBlock(), _createBlock(_component_el_popover, {
                key: 0,
                placement: "bottom",
                title: "选择图案",
                width: "440",
                trigger: "click"
              }, {
                reference: _withCtx(() => [_createVNode(_component_el_button, {
                  class: "p-0 w-8 h-8"
                }, {
                  default: _withCtx(() => [item ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: item,
                    alt: "icon",
                    class: "w-5 h-5 object-contain"
                  }, null, 8, _hoisted_20)) : _createCommentVNode("", true)]),
                  _: 2
                }, 1024)]),
                default: _withCtx(() => [_createVNode(IconSelector, {
                  onSelect: $event => handleSelect(key, index, $event)
                }, null, 8, ["onSelect"])]),
                _: 2
              }, 1024)) : item ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: item,
                alt: "icon",
                class: "w-5 h-5 object-contain"
              }, null, 8, _hoisted_21)) : _createCommentVNode("", true)]);
            }), 128))]), _createVNode(_component_el_button, {
              onClick: $event => handleSelectAnswer(key),
              disabled: __props.reviewMode,
              type: (props.editMode ? key == __props.data.rightAnswer : selectedAnswer.value == key) ? 'primary' : 'default'
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(key), 1)]),
              _: 2
            }, 1032, ["onClick", "disabled", "type"])]);
          }), 128))])]),
          _: 1
        })]),
        _: 1
      }), __props.reviewMode || __props.editMode ? (_openBlock(), _createBlock(_component_el_row, {
        key: 1,
        class: "colFlex bothCenter mt32"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, "正确答案：" + _toDisplayString(__props.data.rightAnswer), 1), __props.review ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          style: _normalizeStyle({
            color: __props.review.result ? 'green' : 'red'
          })
        }, "您的答案：" + _toDisplayString(__props.review.answer), 5)) : _createCommentVNode("", true)]),
        _: 1
      })) : _createCommentVNode("", true)]);
    };
  }
};